module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c9dd72975cc161133dc267e735f7835f.png";